import { css } from 'lit'

export default css`
    :host {
        display: flex;
    }

    .wrapper {
        align-items: center;
        display: flex;
        gap: 6px;
        width: fit-content;
        border-radius: 4px;
        padding: 4px 8px;
        height: 16px;
    }

    .wrapper.red {
        color: var(--red-500);
        background: var(--red-100);
    }

    .wrapper.orange {
        color: var(--orange-400);
        background: var(--orange-100);
    }

    .wrapper.teal {
        color: var(--teal-500);
        background: var(--teal-100);
    }

    .wrapper.green {
        color: var(--green);
        background: var(--backgroundGreen);
    }

    .wrapper.grey {
        color: var(--darkGrey);
        background: var(--darkerCloudGrey);
    }

    .wrapper.grey > zaptic-icon {
        color: var(--grey3);
    }

    .wrapper.large {
        height: unset;
        padding: 12px 16px;
        width: 100%;
    }

    .icon-wrapper {
        display: flex;
    }

    zaptic-icon {
        display: contents;
    }

    .label {
        font-weight: var(--font-weight-black);
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 1px;
        text-transform: uppercase;
        align-self: end;
    }

    .label.red {
        color: var(--red-500);
    }

    .label.orange {
        color: var(--orange-400);
    }

    .label.green {
        color: var(--green);
    }

    .label.grey {
        color: var(--grey-700);
    }

    .label.font-medium {
        font-weight: var(--font-weight-medium);
    }

    .label.normal-case {
        text-transform: unset;
    }

    .wrapper.large > .label {
        align-self: unset;
        font-size: 16px;
        line-height: unset;
    }
`
